import { createFileRoute } from '@tanstack/react-router'

import { ReturnVehicle } from '@/features/drives/return-vehicle'
import { handoverGate } from '@/features/handover/gate'

/**
 * A walk-in's return desk, at `/drives/{id}/return`: the same desk and the same
 * `POST /activities/{id}/return` as the booking's, reached by the only id a walk-in has.
 */
export const Route = createFileRoute('/_app/drives/$driveId_/return')({
  ...handoverGate(),
  component: ReturnVehicle,
})
